export const FETCH_METADATA = 'candidateExperience/views/sessions/FETCH_METADATA'
export const FETCH_METADATA_SUCCESS = 'candidateExperience/views/sessions/FETCH_METADATA_SUCCESS'
export const FETCH_METADATA_ERROR = 'candidateExperience/views/sessions/FETCH_METADATA_ERROR'

export const SIGN_OUT = 'candidateExperience/views/sessions/SIGN_OUT'

export const fetchMetadata = candidateSlug => ({
  type: FETCH_METADATA,
  meta: { candidateSlug },
  payload: {
    fetchingMetadata: true,
    fetchMetadataError: null,
  },
})

export const fetchMetadataSuccess = ({ result }) => ({
  type: FETCH_METADATA_SUCCESS,
  payload: {
    fetchingMetadata: false,
    lastUpdatedMetadata: Date.now(),
    ...result,
  },
})

export const fetchMetadataError = errorMessage => ({
  type: FETCH_METADATA_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const signOut = () => ({
  type: SIGN_OUT,
})

const defaultView = {
  current_state: null,
  disabled: false,
  has_availability: false,
  unread_message_count: 0,

  lastUpdatedMetadata: null,
  fetchingMetadata: false,
  fetchMetadataError: null,
}

const view = (state = defaultView, { type, payload }) => {
  switch (type) {
    case FETCH_METADATA:
    case FETCH_METADATA_SUCCESS:
      return { ...state, ...payload }

    case FETCH_METADATA_ERROR:
      return { ...state, fetchingMetadata: false, fetchMetadataError: payload }

    default:
      return state
  }
}

export default view

export const getSessionView = state => state.views.sessions || defaultView
